import React from "react";

export default function HeroBanner() {
  return (
    <div className="relative h-[500px] bg-gradient-to-r from-blue-600 to-blue-400 flex items-center justify-center text-white">
      <div className="text-center px-4">
        <h1 className="text-5xl font-bold mb-4">Wholesale Products at the Best Prices</h1>
        <p className="text-lg mb-6">Shop top-quality products for your business today!</p>
        <a href="/shop" className="bg-white text-blue-600 px-6 py-3 rounded font-semibold hover:bg-gray-100">
          Shop Now
        </a>
      </div>
    </div>
  );
}
